import React, { lazy } from "react";
import { BC_HQ } from "app_constants";
import { AuditLogsIcon } from "components/icons/AuditLogsIcon";
import { DateRangeSupport } from "helpers/shared/formatters/dates";

import { type FeatureFlags, LD_FEATURE_FLAGS } from "types/context";
import type { ISecondaryNavProps, ISectionProps } from "types/navigation";

const isAuditLogFeatureEnabled = (featureFlags: FeatureFlags) => {
  if (!featureFlags[LD_FEATURE_FLAGS.auditLogPOS]) {
    return false;
  }
  return (
    featureFlags[LD_FEATURE_FLAGS.auditLogChecksCategory] ||
    featureFlags[LD_FEATURE_FLAGS.auditLogServersCategory] ||
    featureFlags[LD_FEATURE_FLAGS.auditLogDevicesCategory] ||
    featureFlags[LD_FEATURE_FLAGS.auditLogPrintersCategory]
  );
};

export const AUDIT_LOG_CHECK_NAV_ITEM: ISecondaryNavProps = {
  feature: "Checks",
  app: BC_HQ,
  component: lazy(
    () => import("containers/audit_logs/checks/components/AuditLogsChecks")
  ),
  level: ["store"],
  scope: ["staff", "superuser"],
  path: "/audit-logs/checks",
  dateSupport: DateRangeSupport.NONE,
  requiresFeatureFlag: LD_FEATURE_FLAGS.auditLogChecksCategory,
  hidesContentToolbar: true,
};
export const AUDIT_LOG_SERVER_NAV_ITEM: ISecondaryNavProps = {
  feature: "Servers",
  app: BC_HQ,
  component: lazy(
    () => import("containers/audit_logs/servers/components/AuditLogsServers")
  ),
  level: ["store"],
  scope: ["staff", "superuser"],
  path: "/audit-logs/servers",
  dateSupport: DateRangeSupport.NONE,
  requiresFeatureFlag: LD_FEATURE_FLAGS.auditLogServersCategory,
  hidesContentToolbar: true,
};
export const AUDIT_LOG_DEVICE_NAV_ITEM: ISecondaryNavProps = {
  feature: "Devices",
  app: BC_HQ,
  component: lazy(
    () => import("containers/audit_logs/devices/components/AuditLogsDevices")
  ),
  level: ["store"],
  scope: ["staff", "superuser"],
  path: "/audit-logs/devices",
  dateSupport: DateRangeSupport.NONE,
  requiresFeatureFlag: LD_FEATURE_FLAGS.auditLogDevicesCategory,
  hidesContentToolbar: true,
};
export const AUDIT_LOG_PRINTER_NAV_ITEM: ISecondaryNavProps = {
  feature: "Printers",
  app: BC_HQ,
  component: lazy(
    () => import("containers/audit_logs/printers/components/AuditLogsPrinters")
  ),
  level: ["store"],
  scope: ["staff", "superuser"],
  path: "/audit-logs/printers",
  dateSupport: DateRangeSupport.NONE,
  requiresFeatureFlag: LD_FEATURE_FLAGS.auditLogPrintersCategory,
  hidesContentToolbar: true,
};

const AUDIT_LOGS: ISectionProps = {
  feature: "Audit Logs",
  icon: <AuditLogsIcon />,
  path: "/audit-logs",
  level: ["store"],
  dateSupport: DateRangeSupport.NONE,
  requiresFeatureFlagHandler: isAuditLogFeatureEnabled,
  subSections: [
    {
      feature: "Dashboard",
      app: BC_HQ,
      component: lazy(() => import("containers/audit_logs/dashboard")),
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/audit-logs/dashboard",
      dateSupport: DateRangeSupport.NONE,
      hidesContentToolbar: true,
    },
    AUDIT_LOG_CHECK_NAV_ITEM,
    AUDIT_LOG_SERVER_NAV_ITEM,
    AUDIT_LOG_DEVICE_NAV_ITEM,
    AUDIT_LOG_PRINTER_NAV_ITEM,
  ],
};

export default AUDIT_LOGS;
